import { Spinner } from "@fluentui/react-components";
import { AuthGuard } from "../auth/AuthGuard";
import { ConversationView } from "../features/brief/ConversationView";

export function BriefsNewRoute() {
  return (
    <AuthGuard fallback={<Spinner label="Authentification requise..." />}>
      <ConversationView />
    </AuthGuard>
  );
}
